import { createSlice } from "@reduxjs/toolkit";

const myAppsSlice = createSlice({
    name: "myApps",
    initialState: {
        options: [],
        localReduxData: {
            app: {},
            apps: [],
            stores: [],
        },
        steps: {}
    }
    ,
    reducers: {
        setOptions: (state, action) => {
            state.options = action.payload;
        },
        setLocalReduxData: (state, action) => {
            const payload = action?.payload

            state.localReduxData = {
                app: payload?.app || state.localReduxData.app,
                apps: payload?.apps || state.localReduxData.apps,
                stores: payload?.stores || state.localReduxData.stores
            }
        },
        setSteps: (state, action) => {
            const payload = action?.payload

            state.steps = payload
        },
    },
});

export default myAppsSlice;
